import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-43a84ec2"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1",
  height: "22",
  viewBox: "0 0 1 22",
  fill: "none"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M0.5 1L0.499999 21",
  stroke: "url(#paint0_linear_4484_17707)",
  "stroke-linecap": "round"
}), /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("linearGradient", {
  id: "paint0_linear_4484_17707",
  x1: "0",
  y1: "1",
  x2: "-8.74228e-07",
  y2: "21",
  gradientUnits: "userSpaceOnUse"
}, [/*#__PURE__*/_createElementVNode("stop", {
  "stop-color": "#E3E3E3",
  "stop-opacity": "0.3"
}), /*#__PURE__*/_createElementVNode("stop", {
  offset: "0.5",
  "stop-color": "#E3E3E3"
}), /*#__PURE__*/_createElementVNode("stop", {
  offset: "1",
  "stop-color": "#E3E3E3",
  "stop-opacity": "0.4"
})])])])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_variable_styled_bar = _resolveComponent("variable-styled-bar");
  const _component_flex_row = _resolveComponent("flex-row");
  return _openBlock(), _createBlock(_component_flex_row, {
    class: "signed-bar",
    align: "left",
    style: _normalizeStyle($options.signedStyle)
  }, {
    default: _withCtx(() => [$props.value < 0 ? (_openBlock(), _createBlock(_component_variable_styled_bar, {
      key: 0,
      class: "negative",
      value: Math.abs($props.value),
      max: $props.max,
      min: $props.min,
      color: $props.negativeColor,
      height: $props.height
    }, null, 8, ["value", "max", "min", "color", "height"])) : _createCommentVNode("", true), _hoisted_1, $props.value > 0 ? (_openBlock(), _createBlock(_component_variable_styled_bar, {
      key: 1,
      class: "positive",
      value: Math.abs($props.value) - $props.negativeMin,
      max: $props.max,
      min: $props.min,
      color: $props.positiveColor,
      height: $props.height
    }, null, 8, ["value", "max", "min", "color", "height"])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["style"]);
}